import React from "react";

import {
  FaBookOpen,
  FaLayerGroup,
  FaListOl,
  FaQuestionCircle,
  FaUser,
} from "react-icons/fa";

import {
  getTutorialRoleLabel,
} from "../utils/tutorialRoleUtils";

export default function TutorialHero({
  tutorial,
  role,
  sectionCount = 0,
  stepCount = 0,
  faqCount = 0,
}) {
  const roleLabel =
    getTutorialRoleLabel(role);

  return (
    <section className="pt-[130px] relative overflow-hidden rounded-[30px] border border-slate-800 bg-slate-950 text-white shadow-[0_30px_80px_-35px_rgba(15,23,42,0.95)]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(124,58,237,0.45),transparent_34%),radial-gradient(circle_at_top_right,rgba(14,165,233,0.30),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(16,185,129,0.18),transparent_34%)]" />

      <div className="absolute -right-20 -top-24 h-72 w-72 rounded-full border border-white/10" />
      <div className="absolute -right-8 -top-10 h-48 w-48 rounded-full border border-white/10" />

      <div className="relative px-5 py-7 sm:px-7 sm:py-9 lg:px-10 lg:py-11">
        <div className="flex flex-col gap-8 xl:flex-row xl:items-end xl:justify-between">
          <div className="max-w-3xl">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-white/80 backdrop-blur">
                <FaBookOpen />
                Tutoriel & Aide
              </span>

              <span className="inline-flex items-center gap-2 rounded-full border border-violet-300/20 bg-violet-400/15 px-3 py-1.5 text-xs font-semibold text-violet-100">
                <FaUser />
                Parcours {roleLabel}
              </span>
            </div>

            <h1 className="mt-5 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
              {tutorial?.title ||
                "Tutoriel MonAppliClub"}
            </h1>

            <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
              {tutorial?.subtitle ||
                "Retrouvez toutes les informations utiles pour utiliser votre application."}
            </p>

            {tutorial?.version ? (
              <div className="mt-5 text-xs text-slate-400">
                Version {tutorial.version}
              </div>
            ) : null}
          </div>

          <div className="grid grid-cols-3 gap-3 sm:gap-4 xl:min-w-[420px]">
            <HeroStat
              icon={<FaLayerGroup />}
              value={sectionCount}
              label="Sections"
              color="violet"
            />

            <HeroStat
              icon={<FaListOl />}
              value={stepCount}
              label="Étapes"
              color="sky"
            />

            <HeroStat
              icon={<FaQuestionCircle />}
              value={faqCount}
              label="Réponses"
              color="emerald"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroStat({
  icon,
  value,
  label,
  color,
}) {
  const colors = {
    violet:
      "bg-violet-400/15 text-violet-200",
    sky: "bg-sky-400/15 text-sky-200",
    emerald:
      "bg-emerald-400/15 text-emerald-200",
  };

  return (
    <div className="rounded-[22px] border border-white/10 bg-white/[0.07] p-3 backdrop-blur sm:p-4">
      <div
        className={`flex h-9 w-9 items-center justify-center rounded-xl ${
          colors[color] ||
          colors.violet
        }`}
      >
        {icon}
      </div>

      <div className="mt-3 text-2xl font-bold">
        {value}
      </div>

      <div className="mt-0.5 text-[11px] uppercase tracking-[0.12em] text-slate-400 sm:text-xs">
        {label}
      </div>
    </div>
  );
}